import React, { useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import axios from "axios";

const CsvUploadDialog = ({
  show,
  onClose,
  onUpload,
  sampleFileName = "sample.csv",
  sampleUrl,
}) => {
  const [file, setFile] = useState(null);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleUpload = () => {
    if (!file) {
      alert("Please select a CSV file to upload.");
      return;
    }
    onUpload(file);
    setFile(null);
    onClose();
  };

  const handleDownloadSample = async () => {
    try {
      const response = await axios.get(sampleUrl, {
        responseType: "blob", // important for binary files
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", sampleFileName); // use the filename from props
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Failed to download sample CSV:", error);
      alert("Failed to download sample CSV.");
    }
  };

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>CSV Operations</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="mb-3">
          <Button
            variant="info"
            onClick={handleDownloadSample}
            className="w-100"
          >
            Download Sample CSV
          </Button>
        </div>
        <hr />
        <Form.Group controlId="formFile" className="mb-3">
          <Form.Label>Upload CSV</Form.Label>
          <Form.Control type="file" accept=".csv" onChange={handleFileChange} />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleUpload}>
          Upload
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CsvUploadDialog;
